





































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import InfiniteLoading from 'vue-infinite-loading'
import axios from 'axios'

import _capitalize from 'lodash/capitalize'
import _get from 'lodash/get'

import { OfferItem } from '@/types'
import { BASE_URL } from '@/config'

@Component({
  components: {
    InfiniteLoading,
  },
  methods: {
    _get,
  },
})
export default class OfferItemsTable extends Vue {
  @Prop({ required: true })
  private readonly offerId: string | undefined

  @Prop({ required: true })
  private readonly matching: string | undefined

  @Prop({ required: true })
  private readonly checkedIn: boolean | undefined

  private infiniteId: number = new Date().getTime()
  private itemsPerPage: number = 10
  private offset: number = 0
  private offerItems: OfferItem[] = []

  @Watch('offerId')
  private offerIdChanged(newVal: any | undefined) {
    this.offset = 0
    if (newVal) {
      this.infiniteId += 1
    } else {
      this.offerItems = []
    }
  }

  @Watch('checkedIn')
  private checkedInChanged(newVal: any | undefined) {
    if (newVal) {
      this.offset = 0
      this.offerItems = []
      this.infiniteId += 1
    }
  }

  private mounted(): void {}

  private destroyed(): void {}

  private getCondition(offerItem: OfferItem) {
    return _get(offerItem, 'condition_label') || ''
  }

  private infiniteHandler($state) {
    if (!this.offerId) {
      $state.loaded()
      $state.complete()
      return
    }

    const path = `${BASE_URL}/check-in/offer-items`
    axios
      .get(path, {
        params: {
          offerId: this.offerId,
          matching: this.matching,
          limit: this.itemsPerPage,
          offset: this.offset,
          order: [],
        },
      })
      .then(response => {
        const tempOfferItems = _get(response, 'data')
        $state.loaded()
        if (tempOfferItems.length < this.itemsPerPage) {
          $state.complete()
        }

        this.offerItems = !this.offset ? tempOfferItems : [...this.offerItems, ...tempOfferItems]
        this.offset += tempOfferItems.length || 0
      })
      .catch(err => {
        $state.loaded()
        $state.complete()
      })
      .finally(() => {})
  }
}
